import React, { useContext, useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core';
import AssessmentsList from '../Assessments/List/AssessmentsList';
import ContentWrapper from '../Wrappers/ContentWrapper';
import { FAKE_TITLE_DATA } from '../Shared/FakeDataGenerator';
import { ActivePatientContext } from '../../contexts/ActivePatientProvider';
import { useParams } from 'react-router-dom';
import { PATIENT_TABLE_NAMES } from '../../config/routes';
import OrdersList from '../Orders/List/OrdersList';
import { useDispatch, useSelector } from 'react-redux';
import ClaimsReportingList from '../Claims/List/ClaimsReportingList';
import ClaimReportList from '../ClaimReport/List/СlaimReportList';
import ReportablesList from '../Reportable/List/ReportablesList';
import { useLocation } from 'react-router';
import ResourcesList from '../Resources/List/ResourcesList';
import TableTitle from '../Shared/Table/widgets/TableTitle';
import PatientInfoBlock from '../PatientDashboard/widgets/PatientInfoBlock';
import PatientAdditionalNode from '../PatientDashboard/widgets/PatientAdditionalNode';
import {
  INFO_PANE_PAGES,
  openInfoPane,
  toggleIsInfoPaneExpanded,
} from '../../redux_store/reducer/reducers/infoPaneReducer';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { get } from 'lodash';
import { GET_ASSESSMENTS_COLUMNS } from '../Assessments/constants';
import { GET_RESOURCES_COLUMNS } from '../Resources/constants';
import { GET_ORDER_COLUMNS } from '../Orders/constants';
import { GET_CLAIMS_COLUMNS } from '../Claims/constants';
import { GET_REPORTABLES_COLUMNS } from '../Reportable/constants';

const useStyles = makeStyles((theme) => ({
  paper: {
    overflow: 'hidden',
  },
  actions: {
    overflow: 'hidden',
    minWidth: 220,
    flex: '1 100 auto',
    height: 60,
  },
  addNewButton: {
    height: '100%',
    marginRight: theme.spacing(2),
    padding: 20,
  },
  editButton: {
    border: 'none !important',
    width: 34,
    maxWidth: 34,
    minWidth: 34,
    height: 34,
    borderRadius: '50%',
    transition: '300ms',
  },
  editButtonIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 32,
    height: 32,
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    flex: '100 1 auto',
    maxWidth: '100%',
  },
  patientName: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    padding: '8px 12px',
    marginLeft: -12,
    borderRadius: 10,
    background: 'transparent',
    transition: '.3s',
    fontStyle: 'normal',

    '&:hover': {
      transition: '.3s',
      color: '#0073b0',
    },
  },
  infoIcon: {
    width: 16,
    marginLeft: 4,
    color: '#868686',
  },
}));

const ProgramDashboard = ({}) => {
  const { patientUuid: paramsPatientUuid, accountUuid: paramAccountUuid, tableName, programUuid } = useParams();
  const dispatch = useDispatch();
  const classes = useStyles();
  const { en: { titles } } = useSelector((state) => state.i18n);
  const [filterStyle, setFilterStyle] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const { patientUuid, patientInfo } = useContext(ActivePatientContext);
  const { search } = useLocation();
  // const [openPatientEditModal, togglePatientEditModal] = useState(false);
  const tableRef = useRef();
  const { currentPage } = useSelector((state) => state.infoPane);

  // const handleEditPatient = () => {
  //   togglePatientEditModal(true);
  // };

  const titleText = 'Program Dashboard';

  const patientFullName =
    patientInfo &&
    `${get(patientInfo, 'lastName', '')}, ${get(patientInfo, 'firstName', '')}`;

  return <ContentWrapper
    titleText={<div className={classes.titleContainer}>
      <div style={{
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      }}>
        {titleText}
      </div>
      {/*<Button*/}
      {/*  variant={'outlined'}*/}
      {/*  color={'primary'}*/}
      {/*  onClick={handleEditPatient}*/}
      {/*  className={classes.editButton}*/}
      {/*>*/}
      {/*  <div className={classes.editButtonIcon}>*/}
      {/*    <EditIcon style={{ width: 20, height: 20 }} />*/}
      {/*  </div>*/}
      {/*</Button>*/}
    </div>}
    className={classes.paper}
    titleContainerStyle={{
      flexWrap: 'nowrap',
    }}
    titleStyle={{
      flex: '100 1 auto',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    }}
    hasTopPaddingForSmallScreen={true}
    underTitleText={
      <>
        <PatientInfoBlock
          isReportPage
          isForInitLoading={
            (patientUuid !== paramsPatientUuid) || !patientInfo
          }
        />
        <div className={classes.patientName}
             onClick={(e) => {
               e.preventDefault();
               e.stopPropagation();
               const isPaneAlreadyOpenForThisInfo = ((currentPage?.currentPageContext?.patientUUID ?? currentPage?.currentPageContext?.uuid) === patientUuid);
               if (currentPage?.currentPageName !== INFO_PANE_PAGES.patient_page || !isPaneAlreadyOpenForThisInfo) {
                 dispatch(openInfoPane({
                   currentPageName: INFO_PANE_PAGES.patient_page,
                   currentPageContext: {
                     ...patientInfo,
                     uuid: paramsPatientUuid,
                     accountUUID: paramAccountUuid,
                   },
                 }));
               } else {
                 dispatch(toggleIsInfoPaneExpanded(true));
               }
             }}
        >
          {patientFullName}
          <InfoOutlinedIcon className={classes.infoIcon} />
        </div>
      </>
    }
    countFiltered={filterStyle}
    actionsStyle={classes.actions}
    actions={<PatientAdditionalNode
      activeTableName={tableName}
      tabs={Object.values(PATIENT_TABLE_NAMES).filter(i => i !== PATIENT_TABLE_NAMES.programs)}
      tableKey={'programDashboard'}
    />}
  >
    <div style={{ position: 'relative', height: '100%', width: '100%' }}>
      {
        tableName === PATIENT_TABLE_NAMES.assessments && <AssessmentsList
          setFilterStyle={setFilterStyle}
          setTotalCount={setTotalCount}
          tableTitle={<TableTitle
            titleText={titles.assessments}
            count={totalCount}
            countFiltered={filterStyle}
            smallStyle
          />}
          ref={tableRef}
          q={`programUUID:${programUuid}`}
          hideMenuActions={true}
          columnList={GET_ASSESSMENTS_COLUMNS(true)}
        />
      }
      {
        tableName === PATIENT_TABLE_NAMES.resources && <ResourcesList
          setFilterStyle={setFilterStyle}
          setTotalCount={setTotalCount}
          tableTitle={<TableTitle
            titleText={titles.resources}
            count={totalCount}
            countFiltered={filterStyle}
            smallStyle
          />}
          ref={tableRef}
          q={`patientUUID:${programUuid}`}
          hideMenuActions={true}
          columnList={GET_RESOURCES_COLUMNS(true)}
        />
      }
      {
        tableName === PATIENT_TABLE_NAMES.orders && <OrdersList
          setFilterStyle={setFilterStyle}
          setTotalCount={setTotalCount}
          tableTitle={<TableTitle
            titleText={titles.orders}
            count={totalCount}
            countFiltered={filterStyle}
            smallStyle
          />}
          ref={tableRef}
          q={`programUUID:${programUuid}`}
          hideMenuActions={true}
          columnList={GET_ORDER_COLUMNS(true)}
        />
      }
      {
        tableName === PATIENT_TABLE_NAMES.claimsReporting && <ClaimsReportingList
          setFilterStyle={setFilterStyle}
          setTotalCount={setTotalCount}
          tableTitle={<TableTitle
            titleText={titles.claimsReporting}
            count={totalCount}
            countFiltered={filterStyle}
            smallStyle
          />}
          ref={tableRef}
          q={`programUUID:${programUuid}`}
          hideMenuActions={true}
          columnList={GET_CLAIMS_COLUMNS(true)}
        />
      }
      {
        tableName === PATIENT_TABLE_NAMES.claimReport && <ClaimReportList
          setFilterStyle={setFilterStyle}
          setTotalCount={setTotalCount}
          tableTitle={<TableTitle
            titleText={titles.claimReport}
            count={totalCount}
            countFiltered={filterStyle}
            smallStyle
          />}
          ref={tableRef}
          q={`programUUID:${programUuid}`}
        />
      }
      {
        tableName === PATIENT_TABLE_NAMES.reportables && <ReportablesList
          setFilterStyle={setFilterStyle}
          setTotalCount={setTotalCount}
          tableTitle={<TableTitle
            titleText={titles.reportables}
            count={totalCount}
            countFiltered={filterStyle}
            smallStyle
          />}
          ref={tableRef}
          q={`programUUID:${programUuid}`}
          columnList={GET_REPORTABLES_COLUMNS(true)}
        />
      }
    </div>
  </ContentWrapper>;
};

export default ProgramDashboard;
